import { MODALITIES } from '@vindr/services/constants/study.constant';
import useRoleMemo from '@vindr/utils/hooks/useRoleMemo';
import { Select } from 'antd';
import FormSelect, { FormSelectProps } from '../templates/FormSelect';

const Modality = ({
  name = 'modality',
  label = 'Modality',
  placeholder = 'Select Modality',
  rules,
  required = true,
  disabled,
  multiple,
  ...props
}: FormSelectProps) => {
  const rulesMemo = useRoleMemo({ required, rules, disabled });

  return (
    <FormSelect
      {...{ name, label, placeholder, disabled, ...props }}
      {...((rules || required) && { rules: rulesMemo })}
      {...(multiple && { mode: 'multiple' })}
    >
      {MODALITIES?.map((st) => (
        <Select.Option key={st} value={st}>
          {st}
        </Select.Option>
      ))}
    </FormSelect>
  );
};

export default Modality;
